import { useTheme, Tooltip, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { ReactNode } from "react";

export const DataGridCell = ({ children }: { children: ReactNode }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        // display: "flex",
        marginY: theme.spacing(0.5),
        alignItems: "start",
        height: "100%",
        width: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {children}
    </Box>
  );
};

export const TextCellWithTooltip = ({
  children,
  tooltip,
}: {
  children: ReactNode;
  tooltip?: string;
}) => {
  return (
    <Typography variant="body2" noWrap>
      <Tooltip title={tooltip ?? children}>
        <span>{children}</span>
      </Tooltip>
    </Typography>
  );
};
